import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: flex;
  justify-content: row;
  align-items: center;
  column-gap: 5px;
`;

export const ContentText = styled.p`
  font-size: 16px;
  white-space: pre-wrap;
`;

export const MoreButton = styled.button`
  font-size: 14px;
  color: rgba(34, 34, 34, 0.5);
  border: 0;
  background-color: white;
  cursor: pointer;
`;
